<div *ngIf="!creating && publicPanelData[panelData.id]" class="chart-panel alignRow alignColumn"
    style="position: relative;">
    <button *ngIf="!isHierarchyNode" class="graph-change-button" mat-icon-button
        (click)="toggleShowDeltaBars(panelData)" [disabled]="!publicPanelData[panelData.id]">
        <mat-icon>
            {{publicPanelData[panelData.id] ? (publicPanelData[panelData.id].activeSeries ?? []).length > 0 ?
            publicPanelData[panelData.id].activeSeries![0].type == "Column"
            ? "show_chart" : "bar_chart" : "" : ""}}
        </mat-icon>
    </button>
    <div class="text-panel-title alignRow">
        <span>{{!publicPanelData[panelData.id] ? 'Loading...' : panelData.title || panelData.nodeData.Name}}</span>
    </div>
    <!-- [title]="!publicPanelData[panelData.id] ? 'Loading...' : panelData.title || panelData.nodeData.Name" -->
    <ejs-chart #chart id="chart_{{panelData.id}}" [zoomSettings]="zoomSettings" [legendSettings]='legend'
        [enableCanvas]="true" [tooltip]='tooltipSettings' [primaryXAxis]="sensorXAxis" [crosshair]='crosshair'
        background="#FFFFFF" [border]="borderSettings" [palettes]='palette' (seriesRender)="beforeSeriesRender($event)"
        [series]="(axesReady || !isHierarchyNode) ? publicPanelData[panelData.id] ? publicPanelData[panelData.id].activeSeries ?? [] : [] : []"
        [axes]="(axesReady || !isHierarchyNode) ? axes.slice(1) : []" [primaryYAxis]="(axesReady || !isHierarchyNode) ? axes[0] : {}"
        style="height: 100%; width: 100%; margin: 0.4em;">
    </ejs-chart>
</div>

<div *ngIf="creating && panelData" class="chart-panel alignRow alignColumn">
    <button *ngIf="!isHierarchyNode" class="graph-change-button" mat-icon-button
        (click)="toggleSampleDataBars()">
        <mat-icon>
            {{!showBars ? "show_chart" : "bar_chart"}}
        </mat-icon>
    </button>
    <div class="text-panel-title alignRow">
        <span>{{(panelData.title || panelData.nodeData.Name)}} </span>
        <mat-icon [matMenuTriggerFor]="titleMenu" [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
    </div>
    <ejs-chart #chart id="sum-delta-chart" [zoomSettings]="zoomSettings" [legendSettings]='legend' [enableCanvas]="true"
        [tooltip]='tooltipSettings' [primaryXAxis]="sensorXAxis" [crosshair]='crosshair' background="#FFFFFF"
        [border]="borderSettings" [palettes]='palette' [height]="'250px'" [width]="'750px'">
    </ejs-chart>
</div>

<div *ngIf="creating && !panelData" class="chart-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>Chart</span>
    </div>
    <ejs-chart #chart id="sum-delta-chart" [zoomSettings]="zoomSettings" [legendSettings]='{visible: false}' [enableCanvas]="true"
         [crosshair]='crosshair' background="#FFFFFF"
        [border]="borderSettings" [palettes]='palette' [height]="'250px'" [width]="'750px'">
    </ejs-chart>
</div>

<div *ngIf="!creating && !publicPanelData[panelData.id]" class="spinner alignColumn">
    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/circle-lines.gif">
</div>